// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { GroupQuotaLimitsOperations } from "./groupQuotaLimits/index.js";
export { GroupQuotaLimitsRequestOperations } from "./groupQuotaLimitsRequest/index.js";
export { GroupQuotaLocationSettingsOperations } from "./groupQuotaLocationSettings/index.js";
export { GroupQuotasOperations } from "./groupQuotas/index.js";
export { GroupQuotaSubscriptionAllocationOperations } from "./groupQuotaSubscriptionAllocation/index.js";
export { GroupQuotaSubscriptionAllocationRequestOperations } from "./groupQuotaSubscriptionAllocationRequest/index.js";
export { GroupQuotaSubscriptionRequestsOperations } from "./groupQuotaSubscriptionRequests/index.js";
export { GroupQuotaSubscriptionsOperations } from "./groupQuotaSubscriptions/index.js";
export { GroupQuotaUsagesOperations } from "./groupQuotaUsages/index.js";
export { QuotaOperations } from "./quota/index.js";
export { QuotaOperationOperations } from "./quotaOperation/index.js";
export { QuotaRequestStatusOperations } from "./quotaRequestStatus/index.js";
export { UsagesOperations } from "./usages/index.js";
